import script from "./HrFab.vue?vue&type=script&setup=true&lang=js"
export * from "./HrFab.vue?vue&type=script&setup=true&lang=js"

import "./HrFab.vue?vue&type=style&index=0&id=09cb2ed6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09cb2ed6"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon});
